import { render, staticRenderFns } from "./DialogAddChatMembers.vue?vue&type=template&id=c994c6c6&scoped=true&"
import script from "./DialogAddChatMembers.vue?vue&type=script&lang=ts&"
export * from "./DialogAddChatMembers.vue?vue&type=script&lang=ts&"
import style0 from "./DialogAddChatMembers.vue?vue&type=style&index=0&id=c994c6c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c994c6c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSnackbar,VTextField})
